<script lang="ts">
    
    import { Icon } from "sveltestrap";
    import type { Question } from "../../Model/Question";

    export let question: Question;

</script>

{#if question}
    <h6 class:fw-bold={question.forced}>
        {question.name}
        {#if question.forced}
            <Icon name="shield-fill-exclamation" class="text-warning" />
        {/if}
    </h6>
{/if}

